import { Box, Checkbox, ClickAwayListener, Divider, Grid, IconButton, Typography } from '@mui/material'
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { CannedResponseTemplate, getResponseOfContentType, globalMenuItemData, sendCannedResponsePayload, sendTemplatePayload, updateDirectSendCannedMsgPayload, uploadedMedia } from '../../../../../../models/axiosModel';
import { useShallow } from 'zustand/react/shallow';
import { useRuleBasedInboxStore } from '../../../../../../store/ruleBasedInboxStore';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import agent from '../../../../../../services/api';
import GlobalSearch from '../../../../../../components/utility/GlobalSearch/GlobalSearch';
import GlobalButton from '../../../../../../components/utility/globalButton/button';
import { hasInboxUpdateAccess, isChatbotTextDirectionLtr } from '../../../../../../utils/constants';
import IconsColor from '../../../../../../components/utility/iconsColor';
import { primaryColor, whiteColor } from '../../../../../../utils/colors';
import styles from "../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import SendIcon from '@mui/icons-material/Send';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import BoltIcon from '@mui/icons-material/Bolt';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../../context/chatbotContext';
import GlobalPopUp from '../../../../../../components/utility/globalPopUp';
import CannedResponseEditPopup from './components/cannedResponseEditPopup';
import GlobalMenu from '../../../../../../components/globalMenu';
import globalStrenameDocumentyles from "../../../../../../assets/renameDocument.svg";
import deleteDoc from "../../../../../../assets/deleteDoc.svg";
import GlobalDeletePopup from '../../../../../../components/utility/globalDeletePopup/globalDeletePopup';
import GlobalTooltip from '../../../../../../components/utility/tooltip/globalTooltip';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useGenericStore } from '../../../../../../store/genericStore';
import { emptyCannedResponse } from '../../../../constants';
import { sendCannedResMsg } from '../../../../utils';
import useGenericHook from '../../../../../../hooks/useGenericHook';

interface CannedResponseProps {
    disabledAttchIcon: (flagCheckIfChatIsExpired?: boolean | undefined) => boolean,
    handleSendMessageManually: (inputValue: string, flagMediaMessage: boolean, flagCannedResponseTemplate: boolean, flagTemplateMessage: boolean, selectedMediaSet: uploadedMedia[], sendTemplatePayload: sendTemplatePayload | null, cannedResponsePayload?: sendCannedResponsePayload) => Promise<void>,
} 

const CannedResponse: React.FC<CannedResponseProps> = (props) => {
    
    const { disabledAttchIcon, handleSendMessageManually } = props;
    const { setFlagLoading, userDetail, setUserDetail, handleError, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload; 

    const { cannedResponseList, setCannedResponseList, currentCannedRes, setCurrentCannedRes, setFlagPreviewAndSendCannedResPopup, getCannedResponseDataApi } = useRuleBasedInboxStore(
        useShallow((store) => ({
            cannedResponseList: store.cannedResponseList,
            setCannedResponseList: store.setCannedResponseList,
            currentCannedRes: store.currentCannedRes,
            setCurrentCannedRes: store.setCurrentCannedRes,
            setFlagPreviewAndSendCannedResPopup: store.setFlagPreviewAndSendCannedResPopup,
            getCannedResponseDataApi: store.getCannedResponseDataApi,
        }))
    )

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { isScreenBelow1000 } = useGenericHook();

    const [contentTypeData, setContentTypeData] = useState<getResponseOfContentType[] | null>(null);

    const cannedResIconRef = useRef<HTMLButtonElement | null>(null);

    const [openCannedResMenu, setOpenCannedResMenu] = useState(false);
    const [openCannedResMenuByClick, setOpenCannedResMenuByClick] = useState(false);

    const [isCannedResIconHovered, setIsCannedResIconHovered] = useState(false);
    const [isCannedResMenuHovered, setIsCannedResMenuHovered] = useState(false);

    const [filteredCannedResList, setFilteredCannedResList] = useState<CannedResponseTemplate[] | null>(cannedResponseList);
    const [flagCannedResDetailPopup, setFlagCannedResDetailPopup] = useState<boolean>(false);

    const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<string | null>(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

    const handleMenuOpen = useCallback((event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: string) => {
        event.stopPropagation();
        event.preventDefault();
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
    }, []);

    const handleMenuClose = useCallback(() => {
        setCurrentRowIndex(null);
        setAnchorEl(null);
    }, []);

    const getCannedResponseApi = useCallback(async (canned_response_template_id: string | null, flagDirectSend: boolean, flagToUpdate?: React.Dispatch<React.SetStateAction<boolean>> | ((value: boolean) => void)) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getCannedResponseDataApi(canned_response_template_id);
        if(!(res.status)){
            handleError(res);
        } else {
            if(!canned_response_template_id){
                setCannedResponseList(res?.data); 
                setFilteredCannedResList(res?.data);
            } else {
                let responseMessages = res.data?.[0]?.canned_response_messages?.sort((a: any, b: any) => a.message_sequence - b.message_sequence);
                let data =  {...res.data?.[0], canned_response_messages: responseMessages?.map((msg: any) => {
                    return {
                        ...msg,
                        content_type_id: msg?.content_type?.id,
                    }
                })};
                setCurrentCannedRes(data);
                if(flagToUpdate){
                    flagToUpdate(true);
                }
                if(flagDirectSend){
                    await sendCannedResMsg(data, handleSendMessageManually, userDetail);
                }
            }
        } 
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }, [getCannedResponseDataApi, handleError, handleSendMessageManually, sendCannedResMsg, setFilteredCannedResList,  setCannedResponseList, setCurrentCannedRes, setFlagLoading, userDetail]);

    const getContentTypeApiCall = useCallback(async () => {
        setFlagLoading((prev) => ({...prev,flagRoundLoader: true}));
        const res = await agent.getGenericContentTypes.get();
        if(!(res.status)){
            handleError(res);
        } else {
            setContentTypeData(res.data);
        }
        setFlagLoading((prev) => ({...prev,flagRoundLoader: false}));
    }, [handleError, setFlagLoading]);

    useEffect(() => {
        if(!cannedResponseList){
            getCannedResponseApi(null, false);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
        if (!openCannedResMenuByClick && !isCannedResIconHovered && !isCannedResMenuHovered) {
            setFilteredCannedResList(cannedResponseList);
            setOpenCannedResMenu(false);
        }
        }, 120);

        return () => clearTimeout(timer);
    }, [isCannedResIconHovered, isCannedResMenuHovered]);
    
    const handleMouseEnter = useCallback(async () => {
        setIsCannedResIconHovered(true);

        if (!cannedResponseList) {
            await getCannedResponseApi(null, false);
        }

        if (!openCannedResMenuByClick) {
            setOpenCannedResMenu(true);
        }
    }, [cannedResponseList, getCannedResponseApi, openCannedResMenuByClick]);
    
    const handleMouseLeave = useCallback(() => {
        setIsCannedResIconHovered(false);
    }, []);
    
    const handleCannedResIconClick = useCallback(async () => {
        if (!cannedResponseList) {
            await getCannedResponseApi(null, false);
        }

        if (openCannedResMenu && !openCannedResMenuByClick) {
            setOpenCannedResMenuByClick(true);
            return;
        }

        setOpenCannedResMenu(true);
        setOpenCannedResMenuByClick(true);
    }, [cannedResponseList, getCannedResponseApi, openCannedResMenu, openCannedResMenuByClick]);
    
    const handleCannedResClose = useCallback((event: MouseEvent | TouchEvent | null) => {
        if (event && cannedResIconRef?.current && cannedResIconRef.current.contains(event.target as Node)) {
            return;
        }
        setFilteredCannedResList(cannedResponseList);
        setOpenCannedResMenu(false);
        setOpenCannedResMenuByClick(false);
    }, [cannedResponseList]);
    
    const handleCannedResSearch = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event?.target?.value?.toLowerCase()
        if (cannedResponseList != null) {
            const filteredData = cannedResponseList?.filter((cannedRes) => {
                return cannedRes?.template_title?.toLowerCase()?.includes(query)
            });
            setFilteredCannedResList(filteredData);
        }
    }, [cannedResponseList]);
    
    const handleCreateCannedRes = useCallback(async (flagEdit: boolean, canned_res?: CannedResponseTemplate) => {
        handleCannedResClose(null);
        if(flagEdit){
            await getCannedResponseApi(canned_res?.canned_response_template_id || "", false);
        } else {
            setCurrentCannedRes(emptyCannedResponse);
        }
        if(!contentTypeData){
            await getContentTypeApiCall();
        }
        setFlagCannedResDetailPopup(true);
    }, [contentTypeData, getCannedResponseApi, getContentTypeApiCall, handleCannedResClose, setCurrentCannedRes]);

    const onClickOfSendIcon = useCallback(async (item: CannedResponseTemplate) => {
        handleCannedResClose(null);
        const flagDirectSend = userDetail?.flag_send_direct_canned_message;
        await getCannedResponseApi(item?.canned_response_template_id || "", flagDirectSend, !flagDirectSend ? setFlagPreviewAndSendCannedResPopup : undefined);
    }, [getCannedResponseApi, handleCannedResClose, setFlagPreviewAndSendCannedResPopup, userDetail?.flag_send_direct_canned_message]);

    const getSelectedCannedRes = useCallback(() => {
        return cannedResponseList?.find((cannedRes) => cannedRes?.canned_response_template_id == currentRowIndex);
    }, [cannedResponseList, currentRowIndex]);

    const deleteCannedResponseApi = useCallback(async (id: string) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await agent.deleteCannedResponseTemplate.delete(id);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess("Canned Response Deleted Successfully.")
            await getCannedResponseApi(null, false);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }, [getCannedResponseApi, handleError, setFlagLoading, showSuccess]);

    const handleEditCannedResMenuClick = useCallback(async () => {
        handleCannedResClose(null);
        const cannedRes = getSelectedCannedRes();
        if(cannedRes){
            if(!contentTypeData){
                await getContentTypeApiCall();
            }
            await getCannedResponseApi(cannedRes?.canned_response_template_id || "", false, setFlagCannedResDetailPopup);
        }
    }, [contentTypeData, getCannedResponseApi, getContentTypeApiCall, getSelectedCannedRes, handleCannedResClose]);

    const handleDeleteCannedResMenuClick = useCallback(() => {
        handleCannedResClose(null);
        const cannedRes = getSelectedCannedRes();
        if(cannedRes){
            setCurrentCannedRes(cannedRes);
            setShowDeleteConfirmation(true);
        }
    }, [getSelectedCannedRes, handleCannedResClose, setCurrentCannedRes]);

    const cannedResMenuOptions: globalMenuItemData[] = useMemo(() => [
        {
            type: "item",
            label: "Edit",
            icon: <img alt="" src={globalStrenameDocumentyles} />,
            onClick: handleEditCannedResMenuClick
        },
        {
            type: "item",
            label: "Delete",
            icon: <img alt="" src={deleteDoc} />,
            onClick: handleDeleteCannedResMenuClick
        }
    ], [handleDeleteCannedResMenuClick, handleEditCannedResMenuClick]);

    const onCloseOfDeletePopup = useCallback(() => {
        setShowDeleteConfirmation(false); 
        setCurrentCannedRes(null);
    }, [setCurrentCannedRes]);

    const isCannedResAvailable  = useMemo(() => {
        if(cannedResponseList && cannedResponseList?.length > 0){
            return true;
        }
        return false;
    }, [cannedResponseList])

    const handleDirectSendFlag = useCallback(async (checked: boolean) => {
        setUserDetail((prev) => ({
            ...prev,
            flag_send_direct_canned_message: !checked
        }))

        const payload: updateDirectSendCannedMsgPayload = {
            flag_send_direct_canned_message: !checked
        }

        const res = await agent.updateDirectSendCannedMsg.put(payload);
        if(!(res?.status)){
            handleError(res);
        }
    }, [handleError, setUserDetail]);

    const handleCannedResMenuMouseEnter = useCallback(() => {
        setIsCannedResMenuHovered(true);
    }, []);

    const handleCannedResMenuMouseLeave = useCallback(() => {
        setIsCannedResMenuHovered(false);
    }, []);

    const handleCloseCannedResDetailPopup = useCallback(() => {
        setFlagCannedResDetailPopup(false);
    }, []);

    const handleConfirmDeleteCannedRes = useCallback(() => {
        if(currentCannedRes){
            deleteCannedResponseApi(currentCannedRes.canned_response_template_id || "");
        }
        onCloseOfDeletePopup();
    }, [currentCannedRes, deleteCannedResponseApi, onCloseOfDeletePopup]);

    return (
        <>
            <IconButton
                ref={cannedResIconRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={handleCannedResIconClick}
                disabled={disabledAttchIcon(true)}
                className={`chat-upload-icon-btn ${styles.mediaUploadIconButton} 
                    ${isChatbotTextDirectionLtr(chatBotDetails) ? styles.attachmentIconMargin : styles.attachmentIconZeroMargin} 
                    ${disabledAttchIcon(true) ? styles.attchmentIconLowOpacity : styles.attchmentIconFullOpacity}
                `}
            >
                <BoltIcon className={styles.mediaUploadIcon}/>
            </IconButton>

            {openCannedResMenu && (
                <ClickAwayListener onClickAway={handleCannedResClose}>
                    <Box
                        onMouseEnter={handleCannedResMenuMouseEnter}
                        onMouseLeave={handleCannedResMenuMouseLeave}
                        className={`${styles.cannedResMenuBox} ${!isCannedResAvailable ? styles.noCannedResGrid : ''}`}
                    >
                        {isCannedResAvailable &&
                            <Grid item xs={12} className={`${globalStyles.fullwidth} ${styles.cannedResHeader}`}>
                                <Grid container className={globalStyles.displayFlex} flexWrap={"nowrap"} gap={'10px'}>
                                    <Grid item xs={12}>
                                        {(cannedResponseList && cannedResponseList?.length > 5) ?
                                            <GlobalSearch
                                                fullWidth
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCannedResSearch(e)}
                                                size="small"
                                                placeholder="Search Canned Response"
                                                className={styles.cannedResSearchBar}
                                                sx={{
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "2px !important"
                                                    },

                                                    "& .MuiOutlinedInput-root": {
                                                        paddingLeft: "8px !important"
                                                    }
                                                }}
                                            />
                                            :
                                            <Grid container className={globalStyles.displayFlex} gap={1}>
                                                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight} ${globalStyles.blackColor}`}>
                                                    Canned Responses
                                                </Typography>
                                                <GlobalTooltip
                                                    title={
                                                        <span className={styles.cannedResInfoTooltipText}>
                                                            Canned messages are saved, prewritten replies used for frequently asked questions. They help you respond faster and maintain consistent communication.
                                                            <br />
                                                            Type / to quickly send one.
                                                        </span>
                                                    }
                                                    placement="top"
                                                    arrow
                                                    offset={8}
                                                >
                                                    <HelpOutlineIcon className={styles.cannedResHelpIcon} />
                                                </GlobalTooltip>
                                            </Grid>
                                        }
                                    </Grid>
                                    {hasInboxUpdateAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <Grid item className={`${styles.addCannedResIcon}`}>
                                            <AddIcon onClick={() => handleCreateCannedRes(false)} />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        }

                        <Box className={styles.cannedResBox}>
                            {isCannedResAvailable ? (
                                filteredCannedResList && filteredCannedResList.length > 0 ? (
                                    filteredCannedResList.map((item: CannedResponseTemplate) => (
                                        <Box
                                            key={item.canned_response_template_id}
                                            className={styles.cannedResponseItem}
                                        >
                                            <Grid item>
                                                <Typography
                                                    className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.cannedResTitle}`}
                                                    title={`${item?.template_title} (${item?.canned_response_messages?.length})`}
                                                >
                                                    {`${item?.template_title} (${item?.canned_response_messages?.length})`}
                                                </Typography>
                                            </Grid>

                                            <Grid item>
                                                <Grid
                                                    container
                                                    className={globalStyles.displayFlex}
                                                    gap={1}
                                                    flexWrap={"nowrap"}
                                                >
                                                    <GlobalTooltip
                                                        title={userDetail?.flag_send_direct_canned_message ? 'Send' : 'Preview and Send'}
                                                        placement='top'
                                                        arrow
                                                    >
                                                        <Grid item className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`}>
                                                            <SendIcon className={`${styles.actionIconCannedRes} ${styles.sendIcon}`} onClick={() => onClickOfSendIcon(item)} />
                                                        </Grid>
                                                    </GlobalTooltip>

                                                    <Grid item className={`${globalStyles.displayFlexStyle} ${globalStyles.clickable}`}>
                                                        <MoreVertIcon 
                                                            className={`${styles.actionIconCannedRes}`} 
                                                            onClick={(e:  React.MouseEvent<SVGSVGElement, MouseEvent>) => {
                                                                handleMenuOpen(e, item?.canned_response_template_id ?? '');
                                                            }}
                                                        />
                                                        <GlobalMenu
                                                            anchorEl={anchorEl}
                                                            handleMenuClose={handleMenuClose}
                                                            menuItemData={cannedResMenuOptions}
                                                            open={Boolean(anchorEl)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))
                                ) : (
                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${styles.noCannedResFoundGrid}`}>
                                        No Canned Response Found!
                                    </Typography>
                                )
                                ) : (
                                    <Grid item className={`${globalStyles.fullwidth} ${globalStyles.displayFlex}`} height={'150px'}>
                                        <Grid container className={`${globalStyles.displayFlex} ${globalStyles.flexColumn} ${globalStyles.gapTwo}`}>
                                            <Grid item xs={12}>
                                                <Grid container className={globalStyles.displayFlex} gap={1}>
                                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.secondaryFontWeight} ${globalStyles.greyColor}`}>
                                                        No Canned Response Available Yet!
                                                    </Typography>
                                                    <GlobalTooltip
                                                        title='Canned messages are saved, prewritten replies used for frequently asked questions. They help you respond faster and maintain consistent communication.'
                                                        placement='top'
                                                        arrow
                                                    >
                                                        <span className={`${globalStyles.displayFlex} ${globalStyles.clickable}`} style={{ marginTop: '2px' }}>
                                                            <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                                        </span>
                                                    </GlobalTooltip>
                                                </Grid>
                                            </Grid>
                                            {hasInboxUpdateAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                <GlobalButton
                                                    buttonText={"Create"}
                                                    className='primaryButtonStyle'
                                                    sx={{ width: "130px" }}
                                                    startIcon={
                                                        <IconsColor
                                                            iconName="plus"
                                                            width="15px"
                                                            height="15px"
                                                            fillColor={whiteColor}
                                                        />
                                                    }
                                                    onClick={() => { handleCreateCannedRes(false) }}
                                                />
                                            }
                                        </Grid>
                                    </Grid>
                                )
                            }
                        </Box>
                        
                        {isCannedResAvailable && 
                            <>
                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <Divider />
                                </Grid>

                                <Grid item xs={12} className={globalStyles.fullwidth}>
                                    <Grid container className={`${globalStyles.displayFlex} ${styles.previewCheckBoxGrid}`} gap={1}>
                                        <Checkbox 
                                            className={styles.previewCheckBox}
                                            disableRipple 
                                            checked={!userDetail?.flag_send_direct_canned_message}
                                            icon={ <CheckBoxOutlineBlankOutlinedIcon />}
                                            checkedIcon={<CheckBoxOutlinedIcon />}
                                            onChange={(event) => handleDirectSendFlag(event.target.checked)} 
                                        />
                                        <Grid item className={`${globalStyles.tertiaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                            Preview before sending
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </Box>
                </ClickAwayListener>
            )}

            {flagCannedResDetailPopup && 
                <GlobalPopUp
                    open={flagCannedResDetailPopup}
                    onClose={handleCloseCannedResDetailPopup}
                    handleClose={handleCloseCannedResDetailPopup}
                    flagShowCloseIcon={true}
                    paperMinWidth={isScreenBelow1000 ? "310px" : "650px"}
                    paperMaxwidth={isScreenBelow1000 ? "610px" : "650px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                > 
                    <CannedResponseEditPopup
                        setFlagCannedResDetailPopup={setFlagCannedResDetailPopup}
                        contentTypeData={contentTypeData}
                        getCannedResponseApi={getCannedResponseApi}
                    />
                </GlobalPopUp>
            } 

            {showDeleteConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${currentCannedRes?.template_title}`}
                    open={showDeleteConfirmation}
                    onClose={onCloseOfDeletePopup}
                    onDelete={handleConfirmDeleteCannedRes}
                />
            }
        </>
    )
}

export default CannedResponse
